"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _asObject = _interopRequireDefault(require("./lib/asObject"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var MenuItem = function MenuItem(_ref) {
  var option = _ref.option;
  return /*#__PURE__*/_react["default"].createElement("option", {
    value: option.value,
    disabled: option.disabled
  }, option.name);
};
/** SelectDropdown */


var _default = function _default(props) {
  var _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      _props$value = props.value,
      value = _props$value === void 0 ? '' : _props$value,
      _onChange = props.onChange,
      _props$emptyOption = props.emptyOption,
      emptyOption = _props$emptyOption === void 0 ? '(none)' : _props$emptyOption,
      allowEmpty = props.allowEmpty,
      otherProps = _objectWithoutProperties(props, ["options", "value", "onChange", "emptyOption", "allowEmpty"]);

  var optionTags = [].concat(_toConsumableArray(emptyOption ? [/*#__PURE__*/_react["default"].createElement("option", {
    key: "null",
    value: "",
    disabled: !allowEmpty
  }, emptyOption)] : []), _toConsumableArray(options.map(function (option, index) {
    return /*#__PURE__*/_react["default"].createElement(MenuItem, {
      key: index,
      option: (0, _asObject["default"])(option)
    });
  })));
  return /*#__PURE__*/_react["default"].createElement("select", _extends({}, otherProps, {
    value: value,
    onChange: function onChange(event) {
      return _onChange(event.target.value);
    }
  }), optionTags);
};

exports["default"] = _default;